import {WidgetTypeEnum} from '@pes/ui';

export const CIRCUIT_MANAGEMENT_DASHBOARD_CONFIG: any = {
    reference: 'LBPAS',
    name: 'LBPAS Conseiller',
    template: [
        {
            widgets: [
                {
                    type: WidgetTypeEnum.CIRCUIT_STATUS,
                    layout: 'col-lg-12'
                }
            ]
        },
        {
            widgets: [
                {
                    type: WidgetTypeEnum.ACTION_FO_CIRCUIT_LIST,
                    layout: 'col-md-12'
                }
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/app/config/dashboard/circuit-management-dashboard.config.ts